import React from 'react'

export interface IPicture {
  src: string
  webp?: string
}

interface IPictureProps
  extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  src: string
  retina?: string
  webp?: string
  webpRetina?: string
}

/**
 * This component is using to display Retina + WebP Images
 */
export function Picture(props: IPictureProps) {
  const { src, retina, webp, webpRetina, ...otherProps } = props
  const webpImg = webp && (
    <source srcSet={`${webp}${webpRetina ? ` 1x, ${webpRetina} 2x` : ''}`} type="image/webp" />
  )

  return (
    <picture>
      {webpImg}
      <img src={src} srcSet={retina && `${retina} 2x`} {...otherProps} />
    </picture>
  )
}

export default React.memo(Picture)
